import { render } from "./AppTable.vue?vue&type=template&id=819a522c"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"
script.render = render

export default script